var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_BatchUpdateTitle1"),
        width: "400px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            { attrs: { "label-position": "left", "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "", "label-width": "10px" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { no: "1" },
                      model: {
                        value: _vm.form.listType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "listType", $$v)
                        },
                        expression: "form.listType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(
                          _vm._s(_vm.$t("SystemMaintenance.BookingSuccessful"))
                        )
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.ToBeConfirmed")))
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.BookingFail")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              [0, 1].includes(_vm.form.listType)
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Vessel")))]
                          ),
                          _c("cargo-advance-select", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              no: "5",
                              "select-type":
                                _vm.selectTypeNames.static_data_Vessel,
                              cache: false,
                              filterable: "",
                              "allow-create": true,
                              "default-value": _vm.form.shipName,
                              "static-options": _vm.vesselList
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.onVesselSelectionChange(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Voyage")))]
                          ),
                          _c("cargo-advance-select", {
                            ref: "voyage",
                            staticStyle: { width: "250px" },
                            attrs: {
                              no: "6",
                              "static-options": _vm.voyages || [],
                              cache: false,
                              "default-value": _vm.form.voyage,
                              filterable: "",
                              clearable: "",
                              "allow-create": true,
                              "tag-name": "voyageNo",
                              "tag-value": "voyageNo",
                              "filter-tag-names": ["voyageNo"]
                            },
                            on: {
                              focus: function($event) {
                                return _vm.txtVoyageFocusInHandler()
                              },
                              parentCallBack: function(p) {
                                _vm.onVoyageFlightChange(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfLoading")))]
                          ),
                          _c("cargo-advance-select", {
                            ref: "departurePort",
                            staticStyle: { flex: "1", width: "250px" },
                            attrs: {
                              no: "departurePort",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.form.departurePort,
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.departurePort = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.PortOfDischarge"))
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              no: "dischargePort",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.form.dischargePort
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.dischargingPortCodeChange(p.value)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.DateOfDeparture2"))
                              )
                            ]
                          ),
                          _c("el-date-picker", {
                            staticClass: "departure-date-picker",
                            staticStyle: {
                              flex: "1",
                              "margin-right": "5px",
                              width: "250px"
                            },
                            attrs: {
                              no: "etd",
                              value: _vm.form.etd,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.etdChange }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.DateOfArrival2") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: {
                              flex: "1",
                              "margin-right": "5px",
                              width: "250px"
                            },
                            attrs: {
                              no: "eta",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.etaChange },
                            model: {
                              value: _vm.form.eta,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "eta", $$v)
                              },
                              expression: "form.eta"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.ShippingCompany"))
                              )
                            ]
                          ),
                          _c("cargo-company-select", {
                            ref: "shippingCompany",
                            staticStyle: {
                              display: "inline-block",
                              width: "250px"
                            },
                            attrs: {
                              no: "carrierId",
                              "method-params": {
                                companyLob: "seaExport",
                                seaCmp: true,
                                active: true
                              },
                              "default-value": _vm.form.carrierId || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.form.carrierId = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CabinSpaceNote")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              no: "allocationNote",
                              type: "textarea",
                              rows: 4
                            },
                            model: {
                              value: _vm.form.allocationNote,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "allocationNote", $$v)
                              },
                              expression: "form.allocationNote"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", "label-width": "10px" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { no: "3" },
                              model: {
                                value: _vm.form.fillType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "fillType", $$v)
                                },
                                expression: "form.fillType"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FillSO")))
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FillMBL")))
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FillALL")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "S/O NO." } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "250px" },
                            attrs: { no: "2", type: "textarea", rows: 5 },
                            on: { change: _vm.noteChangeHandler },
                            model: {
                              value: _vm.form.note,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "note", $$v)
                              },
                              expression: "form.note"
                            }
                          }),
                          _c(
                            "div",
                            { staticStyle: { "padding-left": "230px" } },
                            [
                              _vm._v(
                                _vm._s(
                                  "(" +
                                    _vm.notSize +
                                    "/" +
                                    _vm.list.length +
                                    ")"
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", "label-width": "10px" } },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WindowTip1"))),
                            _c("br"),
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WindowTip2")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.listType === 2
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CabinSpaceNote")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              no: "allocationNote",
                              type: "textarea",
                              rows: 4
                            },
                            model: {
                              value: _vm.form.allocationNote,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "allocationNote", $$v)
                              },
                              expression: "form.allocationNote"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }